import(/* webpackMode: "eager", webpackExports: ["BlogsLanding"] */ "/app/app/blogs/BlogsLanding.tsx");
